import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogComponent } from '../../share/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/services/user.service';
import { DialogService } from 'src/services/dialog.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  createPasswordForm!: FormGroup;
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  token: string = '';
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private userService: UserService,
    private dialogService: DialogService,
    private router: Router,
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      console.log(this.token);
    });
   }

  ngOnInit(): void {
    this.createPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+')]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
    }, { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
    const password = formGroup.get('password');
    const confirmPassword = formGroup.get('confirmPassword');
    if (password && confirmPassword && password.value !== confirmPassword.value) {
      return { passwordsDoNotMatch: true };
    }
    return null;
  }

  togglePasswordVisibility(type: 'password' | 'confirmPassword'): void {
    if (type === 'password') {
      this.isPasswordVisible = !this.isPasswordVisible;
    } else if (type === 'confirmPassword') {
      this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
    }
  }
  
  disabledButton(): boolean {
    if(this.createPasswordForm.invalid){
      return true;
    }
    if(!this.checkValidate('noSpecialChar')) {
      return true;
    }
    return false;
  }

  onSubmit(): void {
    if (!this.createPasswordForm.valid) {
      console.log('Form is invalid.');
      return;
    }

    // Handle form submission
    console.log('Form Submitted:', this.createPasswordForm.value);
    // Optionally, reset the form or navigate to another page
    this.create();
  }

  checkValidate(type: string): boolean {
    const password = this.createPasswordForm.get('password')!.value;
    const confirmPassword = this.createPasswordForm.get('confirmPassword')!.value;

    switch (type) {
      case 'passwordNotMatch':
        if (password != '' && confirmPassword != '') {
          return this.createPasswordForm.errors?.['passwordsDoNotMatch'];
        }
        return false;
      case 'length':
        return (password?.length ?? 0) >= 8;
      case 'az':
        return /[a-z]/.test(password);
      case 'AZ':
        return /[A-Z]/.test(password);
      case 'num':
        return /\d/.test(password);
      case 'noSpecialChar': // ห้ามมีอักขระพิเศษ
        return !/[!@#$%^&*(),.?":{}|<>]/.test(password);
      default:
        return false;
    }
  }

  create() {
    this.loading = true;
    var criteria = {
      token: this.token,
      newPassword : this.createPasswordForm.get('password')!.value
    }
    this.userService.resetPassword(criteria).subscribe({
      next: (res) => {
        this.loading = false;
        this.dialogService.openDialog({
          action: 'success',
          title: 'สำเร็จ',
          message: 'ตั้งค่ารหัสผ่านใหม่เสร็จสิ้น'
        }, () => this.router.navigate(['/auth/login']));
      },
      error: (error) => {
        this.loading = false;
        var message = error.error.message;
        if(error.error.message == 'Token expired.') {
          message = 'Token หมดอายุ กรุณาลองใหม่อีกครั้ง';
        }
        this.handleError(message);
      }
    });
  }

  private handleError(message: string) {
    this.loading = false;
    this.dialogService.openDialog({
      action: 'fail',
      title: 'ไม่สามารถดําเนินการได้',
      message: message
    }, () => null);
  }

  openDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {
      callback(result === 'confirm');
    });
  }
}